import includes from 'lodash/includes'
import isEqual from 'lodash/isEqual'
import * as React from 'react'

import { Provider } from './Context'
import { CollapseProp } from './interface'
import Panel from './Panel'
import Section from './Section'
import { CollapseBox } from './style'

class Collapse extends React.Component<CollapseProp> {
  static Panel = Panel
  static Section = Section
  state = {
    activeIds: [] as any,
  }

  componentDidMount() {
    this.setActiveIds()
  }

  componentDidUpdate(prevProps: CollapseProp) {
    const { activeIds } = this.props

    if (!isEqual(prevProps.activeIds, activeIds)) {
      this.setActiveIds()
    }
  }

  setActiveIds = () =>
    this.setState({
      activeIds: this.props.activeIds,
    })

  togglePanel = (id: any) => {
    const { activeIds } = this.state
    let newActiveIds = [...activeIds, id]

    if (includes(activeIds, id)) {
      newActiveIds = activeIds.filter((activeId: any) => activeId !== id)
    }

    this.setState({
      activeIds: newActiveIds,
    })
  }

  render() {
    const { activeIds } = this.state
    const { children } = this.props

    return (
      <Provider value={{ activeIds, toggle: this.togglePanel }}>
        <CollapseBox>{children}</CollapseBox>
      </Provider>
    )
  }
}

export default Collapse
